import { render } from "./textSelector.vue?vue&type=template&id=76b5c748&scoped=true"
import script from "./textSelector.vue?vue&type=script&lang=js"
export * from "./textSelector.vue?vue&type=script&lang=js"

import "./textSelector.vue?vue&type=style&index=0&id=76b5c748&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b5c748"]])

export default __exports__